export default __webpack_public_path__ + "static/media/CarDetailingHeavyCutVOCFree.66567cc0.jpg";